import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TeamNotificationService {
  private deleteCard = new Subject<string>();
  deleteNotification$ = this.deleteCard.asObservable();

  private changeActivity = new Subject<{ cardId: bigint }>();
  changeActivityNotification$ = this.changeActivity.asObservable();

  notifyDelete(cardId: string) {
    this.deleteCard.next(cardId);
  }

  notifyChangeActivity(cardId: bigint) {
    this.changeActivity.next({cardId});
  }

}
